/* eslint-disable no-unused-vars */
import Vue from "vue";

export default {
	state: {},
	mutations: {},
	actions: {
		getExportHistory(_, filterData) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("export/history", filterData)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getExportSuppliers() {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("export/suppliers")
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		downloadExportFile(_, idExport) {
			this.state.loading = true;
			Vue.prototype.$http
				.download(`export/download/${idExport}`)
				.then((response) => {
					this.state.loading = false;

					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					let contentDisposition = response.headers["content-disposition"];
					let start = contentDisposition.indexOf("filename=") + 9;
					let end = contentDisposition.indexOf(";", start);
					var fileName = contentDisposition.substring(start, end).replaceAll('"', "");

					var fURL = document.createElement("a");

					fURL.href = fileURL;

					fURL.setAttribute("download", fileName);
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch(() => {
					this.state.loading = false;
				});
		},
		uploadExportFile(_, data) {
			return new Promise((resolve, reject) => {
				let formData = new FormData();
				formData.append("file", data);
				Vue.prototype.$http
					.post(`export/upload`, formData)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error.message);
						reject(error);
					});
			});
		},
		getExportErrors(_, idExport) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("export/errors", { idExport })
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getExportInviteFollowUp(_, filter) {
			this.state.loading = true;
			Vue.prototype.$http
			.postDownload("export/inviteFollowUp", filter)
			.then((response) => {
				this.state.loading = false;
				
					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", "Acompanhamento de Convites.xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		}
	},
	getters: {}
};
